/** Command palette (Ctrl/⌘+K) (ADR-0055). */
export default {
  en: {
    title: "Search or jump to",
    placeholder: "Type a page, a setting or an action…",
    pages: "Pages",
    actions: "Actions",
    settings: "Settings",
    setting: {
      quietHours: { label: "Quiet hours", where: "Channels › Settings" },
      channelTimezone: { label: "Time zone for channels", where: "Channels › Settings" },
      optOut: { label: "Opt-out words (STOP)", where: "Channels › Settings" },
      messageLimits: { label: "Message limits", where: "Channels › Settings" },
      defaultLanguage: { label: "Default language and digits", where: "Channels › Settings" },
      handover: { label: "Hand-over to staff (desk roles and response time)", where: "Channels › Settings" },
      defaultAgent: { label: "Default agent for channels", where: "Channels › Settings" },
      websiteChat: { label: "Website chat button", where: "Channels › Website chat" },
      connectApps: { label: "WhatsApp, Teams, Slack, Telegram, e-mail", where: "Channels › Connect apps" },
      voice: { label: "Voice for an agent (talk and listen)", where: "Channels › Voice" },
      consents: { label: "Customer consents", where: "Channels › Consents" },
      speechModels: { label: "Speech models (listening and speaking)", where: "Models › Speech" },
      apiKeys: { label: "AI connections and API keys", where: "Models › Connections" },
      modelChoices: { label: "Model choices (names agents use)", where: "Models › Model choices" },
      modelBackups: { label: "Backup models", where: "Models › Backups" },
      routingRules: { label: "Routing rules (private data stays local)", where: "Models › Routing rules" },
      spendingLimits: { label: "Spending limits", where: "Administration › Spending limits" },
      cache: { label: "Saved answers", where: "Models › Saved answers" },
      allowedWebsites: { label: "Websites the browser may open", where: "Administration › Internet access" },
      internetAddresses: { label: "Internet addresses for online AI models", where: "Administration › Internet access" },
      approvalAmounts: { label: "Approval amounts (money limits)", where: "Administration › Approval amounts" },
      usersRoles: { label: "Users and roles", where: "Administration › Users & roles" },
      organisation: { label: "Organisation settings", where: "Administration › Organisation" },
      dataResidency: { label: "Where data is kept (residency)", where: "Administration › Organisation" },
      onlineModels: { label: "Allow online AI models", where: "Administration › Organisation" },
      platformSettings: { label: "Platform settings", where: "Administration › Platform settings" },
      businessCalendar: { label: "Working days, holidays and time zone", where: "Cases › Settings" },
      privacyRules: { label: "Privacy and guardrails", where: "Privacy" },
      rules: { label: "Rules agents follow", where: "Governance › Rules" },
      emergencyStop: { label: "Emergency stop", where: "Governance" },
      knowledge: { label: "Knowledge collections", where: "Knowledge" },
      whenItRuns: { label: "When an agent runs (schedules)", where: "Builder › When it runs" },
      agentOverview: { label: "Everything about one agent", where: "Agent overview" },
    },
    settingWords: {
      quietHours: "night silent do not disturb hours",
      channelTimezone: "timezone clock",
      optOut: "unsubscribe stop opt out",
      messageLimits: "rate per hour per day outbound",
      defaultLanguage: "arabic english digits numbers",
      handover: "human agent desk queue sla escalate",
      defaultAgent: "agent channel",
      websiteChat: "widget embed site",
      connectApps: "whatsapp teams slack telegram mattermost email connector",
      voice: "speech talk listen read aloud kareem",
      consents: "consent permission marketing",
      speechModels: "stt tts whisper voice model transcription",
      apiKeys: "provider key groq gemini mistral openai connection",
      modelChoices: "alias model name",
      modelBackups: "fallback failover",
      routingRules: "route confidential restricted private local",
      spendingLimits: "budget cost money spend",
      cache: "cache cached",
      allowedWebsites: "egress allowlist browser playtomic domain",
      internetAddresses: "egress allowlist internet online provider host groq mistral gemini",
      approvalAmounts: "threshold amount approve limit",
      usersRoles: "user role permission access",
      organisation: "tenant org",
      dataResidency: "region residency",
      onlineModels: "online cloud internet",
      platformSettings: "platform egress classification",
      businessCalendar: "holiday weekend calendar timezone",
      privacyRules: "pii guardrails redaction safety",
      rules: "policy policies",
      emergencyStop: "kill switch stop",
      knowledge: "rag documents collection",
      whenItRuns: "trigger schedule cron webhook",
      agentOverview: "agent overview summary",
    },
    empty: "Nothing matches. Try another word.",
    hint: "↑ ↓ to move · Enter to open · Esc to close",
    shortcut: "Ctrl K",
    action: {
      ask: "Ask an agent",
      newCase: "New case",
      createUser: "Create user",
      howItWorks: "See how the platform works",
      glossary: "Look up a term",
      guide: "Open the user guide",
      tour: "Take the tour",
      theme: "Switch light / dark mode",
    },
  },
  ar: {
    title: "ابحث أو انتقل إلى",
    placeholder: "اكتب اسم صفحة أو إعداد أو إجراء…",
    pages: "الصفحات",
    actions: "الإجراءات",
    settings: "الإعدادات",
    setting: {
      quietHours: { label: "ساعات الهدوء", where: "القنوات › الإعدادات" },
      channelTimezone: { label: "المنطقة الزمنية للقنوات", where: "القنوات › الإعدادات" },
      optOut: { label: "كلمات إلغاء الاشتراك (STOP)", where: "القنوات › الإعدادات" },
      messageLimits: { label: "حدود الرسائل", where: "القنوات › الإعدادات" },
      defaultLanguage: { label: "اللغة والأرقام الافتراضية", where: "القنوات › الإعدادات" },
      handover: { label: "التحويل إلى الموظفين (أدوار المكتب ووقت الاستجابة)", where: "القنوات › الإعدادات" },
      defaultAgent: { label: "الوكيل الافتراضي للقنوات", where: "القنوات › الإعدادات" },
      websiteChat: { label: "زر محادثة الموقع", where: "القنوات › محادثة الموقع" },
      connectApps: { label: "واتساب وتيمز وسلاك وتيليجرام والبريد", where: "القنوات › ربط التطبيقات" },
      voice: { label: "الصوت لوكيل (التحدث والاستماع)", where: "القنوات › الصوت" },
      consents: { label: "موافقات العملاء", where: "القنوات › الموافقات" },
      speechModels: { label: "نماذج الكلام (الاستماع والنطق)", where: "النماذج › الكلام" },
      apiKeys: { label: "اتصالات الذكاء الاصطناعي ومفاتيح API", where: "النماذج › الاتصالات" },
      modelChoices: { label: "خيارات النماذج (الأسماء التي يستخدمها الوكلاء)", where: "النماذج › خيارات النماذج" },
      modelBackups: { label: "النماذج الاحتياطية", where: "النماذج › البدائل" },
      routingRules: { label: "قواعد التوجيه (البيانات الخاصة تبقى محلية)", where: "النماذج › قواعد التوجيه" },
      spendingLimits: { label: "حدود الإنفاق", where: "الإدارة › حدود الإنفاق" },
      cache: { label: "الإجابات المحفوظة", where: "النماذج › الإجابات المحفوظة" },
      allowedWebsites: { label: "المواقع التي يمكن للمتصفح فتحها", where: "الإدارة › الوصول إلى الإنترنت" },
      internetAddresses: { label: "عناوين الإنترنت لنماذج الذكاء الاصطناعي عبر الإنترنت", where: "الإدارة › الوصول إلى الإنترنت" },
      approvalAmounts: { label: "مبالغ الاعتماد (الحدود المالية)", where: "الإدارة › مبالغ الاعتماد" },
      usersRoles: { label: "المستخدمون والأدوار", where: "الإدارة › المستخدمون والأدوار" },
      organisation: { label: "إعدادات الجهة", where: "الإدارة › الجهة" },
      dataResidency: { label: "مكان حفظ البيانات", where: "الإدارة › الجهة" },
      onlineModels: { label: "السماح بنماذج الذكاء الاصطناعي عبر الإنترنت", where: "الإدارة › الجهة" },
      platformSettings: { label: "إعدادات المنصة", where: "الإدارة › إعدادات المنصة" },
      businessCalendar: { label: "أيام العمل والعطلات والمنطقة الزمنية", where: "الحالات › الإعدادات" },
      privacyRules: { label: "الخصوصية والضوابط الوقائية", where: "الخصوصية" },
      rules: { label: "القواعد التي يتبعها الوكلاء", where: "الحوكمة › القواعد" },
      emergencyStop: { label: "الإيقاف الطارئ", where: "الحوكمة" },
      knowledge: { label: "مجموعات المعرفة", where: "المعرفة" },
      whenItRuns: { label: "متى يعمل الوكيل (الجداول)", where: "المُنشئ › متى يعمل" },
      agentOverview: { label: "كل ما يخص وكيلًا واحدًا", where: "نظرة عامة على الوكيل" },
    },
    settingWords: {
      quietHours: "ليل هدوء إزعاج ساعات",
      channelTimezone: "توقيت ساعة منطقة",
      optOut: "إلغاء اشتراك توقف",
      messageLimits: "معدل ساعة يوم صادرة رسائل",
      defaultLanguage: "عربي انجليزي أرقام لغة",
      handover: "موظف مكتب طابور تصعيد تحويل",
      defaultAgent: "وكيل قناة",
      websiteChat: "أداة موقع تضمين",
      connectApps: "واتساب تيمز سلاك تيليجرام بريد",
      voice: "كلام صوت تحدث استماع كريم",
      consents: "موافقة إذن تسويق",
      speechModels: "نسخ صوت كلام نموذج",
      apiKeys: "مزود مفتاح اتصال",
      modelChoices: "اسم نموذج",
      modelBackups: "بديل احتياطي",
      routingRules: "توجيه سري خاص محلي",
      spendingLimits: "ميزانية تكلفة إنفاق",
      cache: "مؤقت",
      allowedWebsites: "مواقع متصفح نطاق",
      internetAddresses: "إنترنت عناوين مزود نماذج",
      approvalAmounts: "حد مبلغ اعتماد",
      usersRoles: "مستخدم دور صلاحية",
      organisation: "جهة منظمة",
      dataResidency: "منطقة إقامة بيانات",
      onlineModels: "إنترنت سحابة",
      platformSettings: "منصة تصنيف",
      businessCalendar: "عطلة نهاية أسبوع تقويم",
      privacyRules: "خصوصية حماية بيانات شخصية",
      rules: "سياسة سياسات قواعد",
      emergencyStop: "إيقاف طارئ",
      knowledge: "مستندات معرفة",
      whenItRuns: "جدول تشغيل مشغل",
      agentOverview: "نظرة عامة وكيل",
    },
    empty: "لا توجد نتائج. جرّب كلمة أخرى.",
    hint: "↑ ↓ للتنقل · Enter للفتح · Esc للإغلاق",
    shortcut: "Ctrl K",
    action: {
      ask: "اسأل وكيلًا",
      newCase: "حالة جديدة",
      createUser: "إنشاء مستخدم",
      howItWorks: "تعرّف على طريقة عمل المنصة",
      glossary: "ابحث عن مصطلح",
      guide: "فتح دليل المستخدم",
      tour: "ابدأ الجولة",
      theme: "التبديل بين الوضع الفاتح والداكن",
    },
  },
};
